/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_IdleInputs */

const en_inbox_na_idle = /** @type {(inputs: Inbox_Na_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All clear`)
};

const id_inbox_na_idle = /** @type {(inputs: Inbox_Na_IdleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua beres`)
};

/**
* | output |
* | --- |
* | "All clear" |
*
* @param {Inbox_Na_IdleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_idle = /** @type {((inputs?: Inbox_Na_IdleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_IdleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_idle(inputs)
	return en_inbox_na_idle(inputs)
});